module.exports = __webpack_public_path__ + "static/pasta200-3c75c60e137246a3192f8813e89461d7.png";